import type { FC, MouseEventHandler, ReactNode } from 'react';

import { ButtonKinds } from 'types/button';
import { twMergeClsx } from 'utils/tw-with-clsx';
import { DynamicTagButton } from 'views/shared/dynamic-tag-button';
import { SpinnerIcon } from 'views/shared/spinner-icon';

interface ButtonProps {
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
  href?: string;
  kind?: ButtonKinds;
}

const buttonStyles =
  'w-full text-center h-[46px] md:h-[50px] rounded-xsmall px-4 py-3 text-base md:text-xl leading-5 md:leading-[30px] font-semibold md:font-bold transition-colors text-white disabled:bg-betCity-gray-400';
const buttonPrimaryStyles = 'active:bg-betCity-gray-300 hover:bg-betCity-gray-300 bg-black';
const buttonSecondaryStyles =
  'bg-white border border-solid border-black text-betCity-gray-100 hover:bg-black/10 hover:text-black';

const Button: FC<ButtonProps> = ({
  children,
  onClick,
  className,
  isLoading,
  href,
  kind = ButtonKinds.primary,
  disabled,
}) => {
  const classes = twMergeClsx(
    buttonStyles,
    kind === ButtonKinds.primary && buttonPrimaryStyles,
    kind === ButtonKinds.secondary && buttonSecondaryStyles,
    className,
  );

  return (
    <DynamicTagButton
      href={href}
      disabled={disabled || isLoading}
      className={classes}
      onClick={onClick}
    >
      {isLoading ? <SpinnerIcon /> : children}
    </DynamicTagButton>
  );
};

export { Button };
